export interface ChangePasswordFormErrors {
  oldPassword?: string
  newPassword?: string
  confirmPassword?: string
}

export interface SupportFormErrors {
  email?: string
  mobileNumber?: string
}

export interface KeysFormErrors {
  fcmKey?: string
  twilioAccountSid?: string
  twilioAuthToken?: string
}

export interface TimezoneFormErrors {
  timezone?: string
}

export interface AboutFormErrors {
  title?: string
  description?: string
}

export const TIMEZONE_OPTIONS = [
  { value: '', label: '--Select--' },
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
  { value: 'America/New_York', label: 'America/New_York (Eastern Time)' },
  { value: 'America/Chicago', label: 'America/Chicago (Central Time)' },
  { value: 'America/Denver', label: 'America/Denver (Mountain Time)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (Pacific Time)' },
  { value: 'Europe/London', label: 'Europe/London (GMT)' },
  { value: 'Europe/Paris', label: 'Europe/Paris (CET)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai (GST)' },
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)' },
  { value: 'Asia/Shanghai', label: 'Asia/Shanghai (CST)' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney (AEDT)' },
  { value: 'Africa/Lagos', label: 'Africa/Lagos (WAT)' },
  { value: 'Africa/Johannesburg', label: 'Africa/Johannesburg (SAST)' },
] as const
